import { render, staticRenderFns } from "./FileUploadConfig.vue?vue&type=template&id=2c95a6f9&scoped=true"
import script from "./FileUploadConfig.vue?vue&type=script&lang=js"
export * from "./FileUploadConfig.vue?vue&type=script&lang=js"
import style0 from "./FileUploadConfig.vue?vue&type=style&index=0&id=2c95a6f9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c95a6f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c95a6f9')) {
      api.createRecord('2c95a6f9', component.options)
    } else {
      api.reload('2c95a6f9', component.options)
    }
    module.hot.accept("./FileUploadConfig.vue?vue&type=template&id=2c95a6f9&scoped=true", function () {
      api.rerender('2c95a6f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/config/FileUploadConfig.vue"
export default component.exports